import { render, staticRenderFns } from "./photoWall.vue?vue&type=template&id=79472430&scoped=true&"
import script from "./photoWall.vue?vue&type=script&lang=js&"
export * from "./photoWall.vue?vue&type=script&lang=js&"
import style0 from "./photoWall.vue?vue&type=style&index=0&id=79472430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79472430",
  null
  
)

export default component.exports